import { InfoOutlined } from '@mui/icons-material'
import { Box, Tooltip, Typography } from '@mui/material'

import { ListTextTooltipWrapper } from '@common/components'
import { useSmallScreen } from '@common/utils'

import { getExistingPropertyProcess, propertyProcessConfig } from './utils'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.row
 */
export default function ProcessCell({ row }) {
  const isSmallScreen = useSmallScreen()

  const process = getExistingPropertyProcess(row)
  const config = propertyProcessConfig[process]
  return (
    <Box display="flex" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {!isSmallScreen.mobile && (
        <Tooltip title={config?.desc ?? 'Description missing'}>
          <InfoOutlined sx={{ fontSize: 20, color: 'primary.main', mr: 1 }} />
        </Tooltip>
      )}
      <ListTextTooltipWrapper tooltip={process}>
        <Typography noWrap variant={isSmallScreen.mobile ? 'caption' : 'body2'}>
          {process}
        </Typography>
      </ListTextTooltipWrapper>
    </Box>
  )
}
